import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";

export class StarStruckSlideShowPage extends SlideShowPage {
    private readonly textContainer:PIXI.Container;
    constructor(texture: PIXI.Texture, textString: string[], textTexture?: PIXI.Texture, textLeft?: boolean) {
        super(undefined, undefined, undefined, undefined);
        this.textContainer = new PIXI.Container();
        if (texture) {
            let featureImage: PIXI.Sprite = new PIXI.Sprite(texture);
            featureImage.anchor.set(0.5);
            this.addChild(featureImage);
        }
            let textStyle:any = {
                fontFamily : "Open Sans",
                fontSize : 24,
                fontWeight : "bold",
                fill : "#ffffff",
                dropShadow : true,
                dropShadowAngle : 8,
                dropShadowBlur : 10,
                dropShadowDistance : 4
            };
            const text1:PIXI.Text = new PIXI.Text(textString[0], textStyle);
            text1.anchor.set(0.5);
            text1.position.set(128 * (textLeft?1:-1), -40);
            this.textContainer.addChild(text1);
            if(textString?.length>1){
                textStyle.fontSize = 40;
                const text2:PIXI.Text = new PIXI.Text(textString[1], textStyle);
                text2.anchor.set(0.5);
                text2.position.set(128 * (textLeft?1:-1), 40);
                this.textContainer.addChild(text2);
            }else {
                const text2:PIXI.Sprite = new PIXI.Sprite(textTexture);
                text2.anchor.set(0.5);
                text2.position.set(128 * (textLeft?1:-1), 40);
                this.textContainer.addChild(text2);
            }
        this.addChild(this.textContainer);

    }
    public hideText():void{
        this.textContainer.visible = false;
        this.textContainer.removeChildren();
    }
}